jQuery(document).ready(function($) {

    const $accordeonTrigger = $('.js-accordeon-trigger');
    const $accordeonTarget = $('.js-accordeon-target');

    $accordeonTrigger.on('click', function() {
        const $trigger = $(this);
        $trigger.toggleClass('active');
        const target = $trigger.data('accordeon');
        $('[data-accordeon="'+target+'"]').toggleClass('active');
    });
});